export interface Team {
	Id:number;
	Name:string;
	DateCreatedUtc:string;
}

class CreateTeamModel {
	name: string;
	constructor() {
		this.name = "";
	}
}

export class CreateTeamForUserModel extends CreateTeamModel {
	ownerId: string;
}

export class EditTeamModel extends CreateTeamModel {
	id: number;
	constructor(team: Team) {
		super();
		this.id = team.Id;
		this.name = team && team.Name;
	}
}



// WEBPACK FOOTER //
// ./src/app/models/inModels/Team.ts